export default __webpack_public_path__ + "static/media/MatEnergy.c4fb47c8.jpeg";